// extracted by mini-css-extract-plugin
export default {"rating":"pC-z","numberOfStars":"qC-z","count":"rC-z","barGraphSpacing":"sC-z","barGraph":"tC-z"};